// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import template from "./bao-dialog-template.html";
import guid from "./guid";
export class DialogButton {
	public Enabled = ko.observable(true);
	public IsDefault?= ko.observable(true);
	public Title: KnockoutObservable<string> | any;
	public Click: () => void;
	constructor(dialog?, title?, click?) {
		this.Title = title != undefined ? title : ko.observable("");
		this.Click = click != undefined ? click : function () {
			dialog.Close();
		};
	}
	public Focus?= function () { };
}
Bao.Dialogs = [];
class BaoDialogViewModel {
	public static ButtonFactory = DialogButton;
	public Buttons: KnockoutObservableArray<DialogButton>;
	public Title: KnockoutObservable<string>;
	public VerticalMode = ko.observable("top");
	public IsLoading = ko.observable(false);
	public TemplateName = ko.observable<string>();
	public Template = ko.observable("");
	public ViewModel = ko.observable<any>({});
	public Width = ko.observable<string | number>("1200px");
	public WidthStyle = ko.observable("1200px");
	public DialogResult = ko.observable();
	public SetPosition: () => void;
	public Destroy: () => void;
	public dispose: () => void;
	public CloseButtonClicked: () => void;
	public Close: () => void;
	public BeforeClose: () => void;
	public Closed: () => void;
	public Open: (callInit?: boolean) => JQueryPromise<any>;
	public Focus: () => void;
	public Hide: () => void;
	public Show: () => void;
	public Destroyed = false;

	constructor(initTitle?, initMessage?, type?) {
		const self = this;
		let _initialized = false;
		let _subs = [];
		const modalBackgroundTemplate = '<div class="modal background"></div>';
		let $modalBackground, $modalContent;
		if (ko.isObservable(initTitle)) {
			_subs.push(initTitle.subscribe(function () {
				self.Title(initTitle());
			}));
			self.Title = ko.observable(initTitle());
		} else {
			self.Title = ko.observable(initTitle);
		}
		self.Buttons = ko.observableArray([new DialogButton(self, Bao.Session.GetMessage("msgOk"))]);
		// subscribes
		_subs.push(self.VerticalMode.subscribe(function () {
			self.SetPosition();
		}));
		_subs.push(self.ViewModel.subscribe(function () {
			setTemplate();
		}));
		_subs.push(self.Template.subscribe(function () {
			setTemplate();
		}));
		_subs.push(self.Width.subscribe(function (newValue) {
			if (typeof newValue == "string") {
				self.WidthStyle(newValue);
			} else {
				self.WidthStyle(newValue + "px");
			}
			// $(".modal-dialog", $modalContent).css("max-width", newValue);
		}));
		// functions
		const setTemplate = function () {
			if (_initialized && self.Template() != null) {
				if (self.TemplateName() != null && Bao.Templates[self.TemplateName()] != null) {
					delete Bao.Templates[self.TemplateName()];
				}
				let _templateId = guid();
				Bao.Templates[_templateId] = self.Template();
				self.TemplateName(_templateId);
				self.SetPosition();
			}
		};
		self.SetPosition = function () {
			let paddingTop = 10;
			if (self.VerticalMode() == "middle") {
				paddingTop = $(window).height() / 2 - $(".modal-content", $modalContent).height() / 2;
				if (paddingTop < 10) {
					paddingTop = 10;
				}
			}
			$(".modal-dialog", $modalContent).css("padding-top", paddingTop);
		};
		self.Destroyed = false;
		self.Destroy = function () {
			if (self.Destroyed == false) {
				if ($modalContent != null && $modalContent.length > 0) {
					ko.removeNode($modalContent[0]);
				}
				for (let i = 0; i < _subs.length; i++) {
					_subs[i].dispose();
				}
				if (self.TemplateName() != null && Bao.Templates[self.TemplateName()] != null) {
					delete Bao.Templates[self.TemplateName()];
				}
				if ($modalBackground != null && $modalBackground.length > 0) {
					$modalBackground.remove();
				}
				_initialized = false;
				$(document).off("keydown", escEvent);
				self.Destroyed = true;
			}
		};
		self.dispose = function () {
			self.Destroy();
			self.Template(null);
			self.ViewModel(null);
		};
		self.CloseButtonClicked = function () {
			self.Close();
		};
		self.Close = function () {
			if (_initialized) {
				self.BeforeClose();
				self.Hide();
				self.Destroy();
				self.Closed();
				_openDeferred.resolve();
			}
		};
		self.BeforeClose = function () {
			// dummy
		};
		self.Closed = function () {
			// dummy
		};
		let _openDeferred: JQueryDeferred<any>;
		self.Open = function (callInit?: boolean) {
			if (callInit == true || callInit == null) {
				init();
			}
			self.Show();
			self.SetPosition();
			self.Focus();
			_openDeferred = $.Deferred<any>();
			return _openDeferred.promise();
		};
		self.Focus = function () {
			let focused = false;
			ko.utils.arrayForEach(self.Buttons(), function (item) {
				if (!focused && ko.unwrap(item.IsDefault)) {
					item.Focus();
					focused = true;
				}
			});
		};
		let _scrollPosition = 0;
		self.Hide = function () {
			Bao.Dialogs.splice(-1, 1);
			if ($modalBackground != null) {
				$modalBackground.hide();
			}
			if ($modalContent != null) {
				$modalContent.hide();
			}
			if (Bao.Dialogs.length == 0) {
				$("body", document).removeClass("modal-open");
			}
			$(window).scrollTop(_scrollPosition);
		};
		self.Show = function () {
			_scrollPosition = $(window).scrollTop();
			$("body", document).addClass("modal-open");
			Bao.Dialogs.push(self);
			$modalBackground.show();
			$modalContent.show();
		};
		const escEvent = function (e) {
			if (e.keyCode == 27) {
				self.Close();
			}
		};
		const init = function () {
			$(document).on("keydown", escEvent);
			$modalBackground = $(modalBackgroundTemplate);
			$modalContent = $(template);
			// $modalFooter = $(modalFooterTemplate);
			// $modalHeader = $(modalHeaderTemplate);
			// $modalbody = $(modalbodyTemplate);
			$(".modal-dialog", $modalContent).css("width", "auto");
			// $modalbody.css("overflow-y", "auto"); //overflow-y wurde wegen touch Geräten hinzugefügt, verursacht aber, dass position: absolute Elemente nicht aus dem Dialog "heraus" ragen können
			// $(".modal-content", $modalContent).append($modalHeader).append($modalbody).append($modalFooter);
			$(document.body).append($modalContent).append($modalBackground);
			ko.applyBindings(self, $modalContent[0]);
			if (initMessage != null) {
				if (typeof ko.unwrap(initMessage) === "string") {
					if (ko.isObservable(initMessage)) {
						_subs.push(initMessage.subscribe(function () {
							self.Template(initMessage());
						}));
					}
					self.Template(ko.unwrap(initMessage));
				} else {
					const loadingStateBeforeInit = self.IsLoading();
					if (loadingStateBeforeInit === false) {
						self.IsLoading(true);
					}
					$.when(initMessage).then((message) => {
						self.Template(message);
						if (loadingStateBeforeInit === false) {
							self.IsLoading(false);
						}
					});
				}
			}
			switch (type) {
				case "yesno":
					self.Buttons([
						new DialogButton(self, Bao.Session.GetMessage("msgYes"), function () { self.Close(); self.DialogResult(true); }),
						new DialogButton(self, Bao.Session.GetMessage("msgNo"), function () { self.Close(); self.DialogResult(false); })
					]);
					self.Width("400px");
					self.Open(false);
					break;
				case "question":
					self.Buttons([
						new DialogButton(self, Bao.Session.GetMessage("msgYes"), function () { self.Close(); self.DialogResult(true); }),
						new DialogButton(self, Bao.Session.GetMessage("msgNo"), function () { self.Close(); self.DialogResult(false); }),
						new DialogButton(self, Bao.Session.GetMessage("msgCancel"), function () { self.Close(); self.DialogResult(null); })
					]);
					self.Width("400px");
					self.Open(false);
					break;
				case "info":
					self.Buttons([
						new DialogButton(self, Bao.Session.GetMessage("msgOk"), function () { self.Close(); })
					]);
					self.Width("400px");
					self.Open(false);
					break;
			}
			_initialized = true;
			setTemplate();
			// $(".modal-dialog", $modalContent).css("max-width", self.Width());
		};
		if (type != undefined) {
			init();
		}
	}

}
export default BaoDialogViewModel;
